import { ToastType } from 'react-toastify';
import { getObjectSelectedClient } from '@domain/object-selected';
import { showToast } from '../../../shared/components/messages-and-errors/ToastsNotifications';
import { createMiddleware } from '../../../shared/redux';

import {
    PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS,
    PIPEDRIVE_GET_DATA_REQUEST_ERROR,
    PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR,
} from './pipedrive.state';
import { getActiveIntegrationsAction } from '../integrations-list/integrations-list.state';
import { API_FAIL_DEFAULT_OP_MESSAGE, API_SUCCESS_OP_MESSAGE } from './pipedrive.constants';
import { getErrorKey } from '../../../shared/utils/errors';

const defaultToastProps = {
    autoClose: 2000, toastId: 'pipedrive-toast', height: 300,
};

export const pipedriveMiddleware = createMiddleware({
    [PIPEDRIVE_GET_DATA_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'pipedrive-get-data-error',
        });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'pipedrive-save-error',
        });
    },
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state) => {
        const { id } = getObjectSelectedClient(state);

        showToast(API_SUCCESS_OP_MESSAGE, ToastType.SUCCESS, defaultToastProps);

        return getActiveIntegrationsAction(id);
    },
});
